export default __webpack_public_path__ + "static/media/bumper_1.515afb23.jpg";